<mcg-window #formAsociarTarjeta [loading]="loading()" [width]="600" [height]="450" [actions]="actions" [canResize]="false"
  (actionButtonClicked)="actionButtonClicked($event)" (windowClosed)="onClose()"
  [title]="translate('Asociar') + ' ' + translate('Tarjeta') + ' ' + (tarjetaToAsociar.descripcion ?? '')">

  <app-header #header [buscadorAPI]="true" [buscador]="true" [filtro]="true" [resetFiltro]="true"
    [filterApiError]="errorAlBuscar" (eventFilter)="eventFilter()" (eventResetFilter)="eventResetFilter()"
    (eventBuscador)="onBuscar()">
  </app-header>

    <div class="row" style="background-color: transparent; width: 100%; height: calc(100% - 80px);">
      <div class="inputsRow">
        <div class="row" style="width: 45%;">
          <span style="display: block;">
            <div style="margin-top: 5px">
              {{ translate('Ciudadano') }}
            </div>
            <jqxInput [width]="'100%'" [theme]="environment.tema" [disabled]="true" [value]="ciudadanoSelec !== null ? ciudadanoSelec.nombre + ' ' + ciudadanoSelec.apellidos : ''">
            </jqxInput>
          </span>
        </div>

        <div class="row" style="width: 45%">
          <span style="display: block;">
            <div style="margin-top: 5px">
              {{ translate('Direccion') }}
            </div>
            <jqxInput [width]="'100%'" [theme]="environment.tema" [disabled]="true"
              [value]="direccionSelec !== null ? direccionSelec.direccion + ', ' + direccionSelec.numero + ', ' + direccionSelec.poblacion + '(' + direccionSelec.provincia + ')' : ''">
            </jqxInput>
          </span>
        </div>
      </div>

      <div style="height: calc(100% - 45px); width: 100%;">
        <jqxGrid #gridDropDownCiudadanos [appCellClick] [theme]="environment.tema" [filterable]="true" [sortable]="true"
          [rowsheight]="20" [columnsheight]="20" [source]="adapterCiudadanos" [columns]="columnsCiudadanos"
          [rowdetails]="true" [rowdetailstemplate]="rowdetailstemplate" [initrowdetails]="initRowDetails"
          [localization]="langGrid" [enablebrowserselection]="true" [height]="'100%'" [width]="'100%'"
          (onRowexpand)="onRowExpand($event)" (onRowcollapse)="onRowCollapse($event)">
        </jqxGrid>
      </div>
  </div>
</mcg-window>
